<template>
  <div class="group">
    <label :for="id" :class="labelClass" class="has-[:focus-visible]:bg-grey-50 flex justify-between items-center gap-4 p-4 lg:px-8 border-t border-light cursor-pointer">
      <span v-if="label" class="label-text" v-text="label" />
      <span class="block rounded-full h-6 w-10 overflow-hidden bg-grey-100 relative has-[:checked]:bg-red-800 group-hover:has-[:checked]:bg-red-900 group-hover:bg-grey-200 transition-colors duration-200">
        <input
          :id="id"
          v-bind="attrs"
          type="checkbox"
          class="sr-only peer"
        >
        <span class="block absolute left-0.5 top-0.5 rounded-full bg-white shadow-md size-5 transition-transform duration-200 peer-checked:translate-x-4" />
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
defineProps({
  id: {
    type: String,
    required: true
  },
  label: {
    type: String,
    required: false,
    default: ''
  },
  labelClass: {
    type: [Object, Array, String],
    required: false,
    default: ''
  }
})

defineOptions({
  inheritAttrs: false
})

const attrs = useAttrs()
</script>
